module.exports = __webpack_public_path__ + "img/AntonAbilov-ArdoqHeadshot1920.05cdca58.jpg";